module.exports = __webpack_public_path__ + "static/img/default-shop.1c743d9f.png";